import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import { InfoIcon, XIcon } from '@primer/octicons-react';
import Select, { components } from 'react-select'
import { TooltipWrapper } from '../../AddMethods';
import { preventinputotherthannumbers } from '../../../../_services/common.service';
// import Switch from "react-switch";
// import { TooltipWrapper } from '../../AddMethods';
// import { InfoIcon } from '../../../icons/icons';
import { aiSimulationButton, aiSimulationUser } from '../../../../_services/common.service';
import './simulationGenarationFilter.css';

// Custom SingleValue component to show tooltip on selected value
const CustomSingleValue = (props) => {
    return (
        <div title={props.data.label}>
            <components.SingleValue {...props} />
        </div>
    );
};

class SimulationGenarationFilter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isSalesCycle:this.props.isSCycle,
        }
    }

    handleIsSalesCycle = () => {
        this.setState({isSalesCycle:!this.state.isSalesCycle},()=>{
            this.props.handleSCycle(this.state.isSalesCycle)
        })
    }

    render() {
        let {branches,selectedBranchidx,selectedTag,mapFields,clusters, isCustomPushEnabled, selectedBrch} = this.props; //mapFields, selectedBrch,

        let filterTagList = (this.props.loadedTagsList&&this.props.loadedTagsList.length>0)?this.props.loadedTagsList.map((item,i)=>{
            return {value:item.id,label:item.tagName}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];
        // Filter branches based on selected cluster
        let filteredBranches = branches;

        if (this.props.selectedClusterId > -1 && clusters && clusters.length > 0) {
            const selectedCluster = clusters.find(cluster => cluster.clusterId === this.props.selectedClusterId);

            if (selectedCluster && selectedCluster.clusterStores && selectedCluster.clusterStores.length > 0) {
                // map clusterStores to match original branch shape
                filteredBranches = selectedCluster.clusterStores.map(cs => {
                    const originalBranch = branches.find(b => b.storeId === cs.id) ?? {};

                    return {
                        storeId: cs.id,
                        storeName: cs.name ?? originalBranch.storeName ?? `Store ${cs.storeId}`,
                        chainId: cs.chainId ?? originalBranch.chainId ?? cs.store?.chainId ?? null,
                        fieldCount: cs.fieldCount ?? originalBranch.fieldCount ?? 0,
                        storeTags: cs.storeTags ?? originalBranch.storeTags ?? [],
                    };
                });
            } else {
                filteredBranches = [];
            }
        }
        let filterBranchList = (filteredBranches&&filteredBranches.length>0)?filteredBranches
        .map((item,i)=>{
            return {value:item.storeId,label:item.storeName,idx:i}
        }):[{value:-1,label:this.props.t("NO_RESULT_FOUND")}];
        
        let filterClusterList = [];
        if (clusters && clusters.length > 0) {
            let filteredClusters = clusters;
            if(!isCustomPushEnabled && selectedBranchidx > -1){
                filteredClusters = filteredClusters.filter(clusterItem => clusterItem.clusterStores?.some(store => store.id === selectedBrch));
            }
            // Push cluster data to filterClusterList
            filterClusterList = filteredClusters.map((item) => ({
                value: `${item.clusterId}:${item.fieldArrayId}`, // Combine both IDs for unique value, because clusterId alone is not unique
                label: `${item.clusterName} - ${item.fieldArrayName}${item?.isDefault ? ' (NEW)' : ' (OLD)'}`,
                clusterId: item.clusterId,
                fieldArrayId: item.fieldArrayId,
            }));
        }

        

        if (!filterClusterList || filterClusterList.length === 0) {
            filterClusterList = [{value:-1,label:this.props.t("NO_RESULT_FOUND")}];
        }
    
        var {isopenfromAffectedSimList}=this.props;
        var cuserdetails = (this.props.signedobj && this.props.signedobj.signinDetails ? this.props.signedobj.signinDetails : null);

        return (
            <div className='simulate-filters-container'>
                <ul className='simulate-filters'>
                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            <label>{this.props.t("Simulate")}</label>
                            <div className='aui-content-left-right simulate-switches'>
                                <ButtonGroup className='aui-per-toggle'>
                                    <Button disabled={isopenfromAffectedSimList} size='sm' active={this.props.isCustomPushEnabled} onClick={(e) => this.props.toggleCustomPushOption(true)}>{this.props.t('custom')}</Button>
                                    <Button disabled={isopenfromAffectedSimList} size='sm' active={!this.props.isCustomPushEnabled} onClick={(e) => this.props.toggleCustomPushOption(false)}>{this.props.t('BY_BRANCH')}</Button>
                                </ButtonGroup>
                            </div>    
                        </div>
                    </li>
                    {/* Hide for clustering implementation */}
                    {/* <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            <label>{this.props.t("FIELD_COUNT")}</label>
                            <input type="text" pattern="[0-9]*" className='form-control form-control-sm fieldcount' disabled={!this.props.isCustomPushEnabled && selectedBranchidx > -1 && this.props.branches[this.props.selectedBranchidx].fieldCount>0} onChange={(e)=>this.props.toggeleSimulateCount(e)} value={this.props.simulateCount}
                            style={{minWidth: "auto",width: "120px"}} onKeyDown={(e)=>preventinputotherthannumbers(e,e.target.value,(this.props.t('Character.FIELD_COUNT')))}></input>
                        </div>
                    </li> */}
                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            <label>{this.props.t("Cluster")}</label>
                            <Select 
                                isDisabled={isopenfromAffectedSimList}
                                isClearable
                                menuPlacement="bottom"
                                placeholder={this.props.t("Cluster_Choose")} 
                                options={filterClusterList} 
                                getOptionValue={opt => opt.value}
                                onChange={(e)=>this.props.toggleClusters(e)}
                                value={
                                    (this.props.selectedClusterId > -1 && this.props.selectedFiledArrayId > -1)
                                    ? filterClusterList.find(o =>
                                        o.value === `${this.props.selectedClusterId}:${this.props.selectedFiledArrayId}`
                                    )
                                    : null
                                }
                                components={{ SingleValue: CustomSingleValue }}
                                className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                                maxMenuHeight={160}    
                                />
                        </div>
                    </li>
                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            <label>{this.props.t("tags")}</label>
                            <Select 
                                isDisabled={isopenfromAffectedSimList}
                                menuPlacement="bottom"
                                placeholder={this.props.t("Select_tags")} 
                                options={filterTagList} 
                                onChange={(e)=>this.props.toggleTags(e)} 
                                value={this.props.defTagName} 
                                className="filter-selec2" size="sm" classNamePrefix="searchselect-inner" 
                                maxMenuHeight={160}    
                                />
                        </div>
                    </li>
                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            
                            <label>
                                {this.props.t("branch")} 
                                {this.props.isCustomPushEnabled?<TooltipWrapper text={this.props.t("CUSTOM_BRANCH_INFO")}>
                                    <span className='branchwarn-icon'><InfoIcon size={16} /></span>
                                </TooltipWrapper>:<></>}
                            </label>
                            <Select
                                isDisabled={isopenfromAffectedSimList}
                                isClearable
                                menuPlacement="bottom"
                                placeholder={this.props.t("SELECT_BRANCH")}
                                options={filterBranchList}
                                onChange={(e)=>this.props.toggleBranches(e, this.props.selectedClusterId)}
                                value={this.props.selectedBranchidx > -1 ? filterBranchList.find(branch => branch.value === selectedBrch):null}
                                components={{ SingleValue: CustomSingleValue }}
                                className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                maxMenuHeight={160}
                                />
                        </div>
                    </li>
                    <li className='list-inline-item filter-item '>
                        {/* Max-variety mode retired (product decision 2026-07-03):
                             the strategy toggle is hidden and every arrange runs
                             share-based. To be reintroduced inside the conserving
                             algorithm as a compliance-constrained variant (sub-1-facing
                             products gain space at the expense of high-facing products
                             within the same brand).
                         <div className='form-group'>
                         <label >{this.props.t("STRATEGY")}</label>
                        <div className='aui-content-left-right simulate-switches'>
                            <ButtonGroup className='aui-per-toggle'>
                                <Button disabled={isopenfromAffectedSimList} size='sm' active={!this.props.isPrioratizeUserPercentage } onClick={(e) => this.props.handlePrioratizeUserPercentage()}>{this.props.t('products')}</Button>
                                <Button disabled={isopenfromAffectedSimList} size='sm' active={this.props.isPrioratizeUserPercentage } onClick={(e) => this.props.handlePrioratizeUserPercentage()}>{this.props.t('FIXED_PER')}</Button>
                            </ButtonGroup>
                            </div>
                        </div>
                        */}
                    </li>
                    <li className='list-inline-item filter-item '>
                        <label >{this.props.t("EDITION")}</label>
                        <div className='aui-content-left-right simulate-switches' styles={{}}>
                            <ButtonGroup className='aui-per-toggle'>
                                <Button disabled={isopenfromAffectedSimList} size='sm' active={this.props.selectedViewTypeSimulation === "current"} onClick={()=> this.props.handleViewTypeChange('current', true)}>{this.props.t("CURRENT")}</Button>
                                <Button disabled={isopenfromAffectedSimList} size='sm' active={this.props.selectedViewTypeSimulation === "base" } onClick={(e) => this.props.handleViewTypeChange('base', true)}>{this.props.t("BASE")}</Button>
                            </ButtonGroup>
                        </div>
                    </li>
                    {/* SIMULATION BTN & AI ARRANGEMENT BTN */}
                    <li className='list-inline-item filter-item'>
                        <Button disabled={isopenfromAffectedSimList}  className="btn-simulate" onClick={()=>this.props.getSimulatePlanogram(false)}>{this.props.t("Simulate")}</Button>        
                    </li>
                    <li className='list-inline-item filter-item'>
                        <Button disabled={isopenfromAffectedSimList}  className="btn-simulate" onClick={()=>this.props.getSimulatePlanogram(true)}>{this.props.t("AI_ARRANGEMENT_BTN")}</Button>        
                    </li>
                    {
                        this.props.isSimulated !== null ? <li className='list-inline-item filter-item'>
                            <Button disabled={isopenfromAffectedSimList} className="btn-simulate" style={{ marginBottom: '2px' }} onClick={() => this.props.handleCopyArrangementToggleState()}>{this.props.t("COPY_ARRANGEMENT")}</Button>
                        </li> : <></>
                    }

                    {/* Acooring to client, hard code the AI simulation user ID at env file */}
                    {/* {aiSimulationUser.includes(cuserdetails?.id?.toString()) && (
                        <li className='list-inline-item filter-item'>
                            <Button disabled={isopenfromAffectedSimList} className="btn-simulate" style={{ marginBottom: '2px' }} onClick={() => this.props.getSimulatePlanogram(true)}>AI {this.props.t("Simulate")}</Button>
                        </li>
                    )} */}
                    {/* uncomment only this to work push */}
                    <li className='list-inline-item filter-item'>
                        {(this.props.selectedBranchidx > -1 && !isopenfromAffectedSimList)? <Button className="btn-simulate btn-push" style={{ marginBottom: '2px' }} onClick={() => this.props.toggelePushBtn()}>{this.props.t("PUSH")}</Button> : <></>}
                    </li>
                    <span className='list-inline mpsim-tags'>{selectedTag.map((xitem, xidx) => {
                        return <li key={xidx} className={'list-inline-item' + (isopenfromAffectedSimList ? " disable" : "")} title={xitem.tagName}>
                            {isopenfromAffectedSimList ? <></> : <span className='close-icon' style={{ opacity: (!this.props.isCustomPushEnabled && this.props.selectedBranchidx > 0) ? "0.1" : "1" }} onClick={() => this.props.removeSimTag(xidx)}><XIcon size={16} /></span>}
                            {xitem && xitem.tagName ? xitem.tagName.substring(0, 25) + (xitem.tagName.length > 25 ? ".." : "") : ""}
                        </li>
                    })}</span>
                </ul>
                {/* <Row className="simulate-filters">
                    <Col xs={12}>
                        <ul className='list-inline mpsim-tags' style={{marginTop: "0px"}}>
                            {selectedTag.map((xitem, xidx) => {
                                return <li key={xidx} className={'list-inline-item'+(isopenfromAffectedSimList?" disable":"")} title={xitem.tagName}>
                                   {isopenfromAffectedSimList?<></>: <span className='close-icon' style={{opacity:(!this.props.isCustomPushEnabled && this.props.selectedBranchidx > 0)?"0.1":"1"}} onClick={() => this.props.removeSimTag(xidx)}><XIcon size={16} /></span>}
                                    {xitem&&xitem.tagName?xitem.tagName.substring(0,25)+(xitem.tagName.length > 25?"..":""):""}
                                </li>
                            })}
                        </ul>
                    </Col>
                </Row> */}
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    
});
export default withTranslation()(withRouter(connect(null, mapDispatchToProps)(SimulationGenarationFilter)))
